module.exports = __webpack_public_path__ + "assets/img/svg/transport-list-templates-block/arrow-check-primary-icon.svg?v=1755677078523";